import React, { useEffect, useState } from 'react';
import { ListGroup } from 'reactstrap';
import { CardTitle, PseudoStates, PageTitle } from '@cordata/buffet';
import { sortBy } from 'lodash';
import { useParams } from 'react-router-dom';

import Form from '~/components/Admission/Form';

import { authorizedInstance as Authorized } from '~/utils';
import ListGroupItemNotes from '~/components/Note/ListGroupItem';

const AdmissionsDetails = () => {
  const params = useParams();
  const [status, setStatus] = useState('loading');
  const [data, setData] = useState();

  useEffect(() => {
    if (params.id !== 'add') {
      Authorized
        .get(`/admissions/${params.id}`)
        .then(r => r.data.data)
        .then(setData)
        .then(() => setStatus('success'))
        .catch(() => setStatus('error'));
    } else {
      setStatus('success');
    }
  }, [params.id]);

  return status === 'success' ? (
    <>
      <PageTitle>
        Admissions
      </PageTitle>

      <Form data={data} />

      {data && data.relationships.notes.length ? (
        <div className="mt-5">
          <CardTitle>Previous Notes</CardTitle>

          <ListGroup>
            {sortBy(data.relationships.notes, ['createdDate']).reverse().map(d => (
              <ListGroupItemNotes
                key={d.id}
                data={{ ...d, ...d.attributes }}
                params={params}
              />
            ))}
          </ListGroup>
        </div>
      ) : undefined}
    </>
  ) : (
    <PseudoStates status={status} />
  );
};
export default AdmissionsDetails;
